export default {
  preloader: false,
  params: {
    date_generate: null
  }
}



// WEBPACK FOOTER //
// ./src/modules/suggested_replacement/state.js